import { Component, OnInit, ViewChild } from '@angular/core';
import { jqxMenuComponent } from 'jqwidgets-ng/jqxmenu';
import { LocalCookiesService } from 'src/app/conta/services/local-cookie.service';
import { Nav } from '../models/nav.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent {

  constructor(private cookieService: LocalCookiesService) { }
  exibirItem(admin: boolean): boolean {
    let userPerfil = this.cookieService.obterUserInfo();
    let perfil = userPerfil?.perfil.nome;
    if (!perfil) return false;
    if (admin)
      return perfil === 'Administrador' || perfil == 'SuperAdministrador'
    return true;
  }
  itensMenu: Nav[] = [
    {
      link: '/inicio',
      name: 'Inicio',
      exact: true,
      admin: false
    },
    {
      link: '/conta/gerenciamento',
      name: 'Gerenciamento de contas',
      exact: true,
      admin: true
    },
    {
      link: '/questao/pesquisa',
      name: 'Edição questões',
      exact: true,
      admin: false
    }
  ]
}
